import { render, staticRenderFns } from "./EmployerDetails.vue?vue&type=template&id=79017779&"
import script from "./EmployerDetails.vue?vue&type=script&lang=js&"
export * from "./EmployerDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmployerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployerDetails.vue"
export default component.exports